export type CleanedAndSuggestions = {
    content: string;
    suggestions: string[];
}

export const extractQuestionSuggestions = (content: string): CleanedAndSuggestions => {
    const suggestionsMatch = content.match(/<suggestions>\s*([\s\S]*?)\s*<\/suggestions>/);
    let suggestions: string[] = [];
    if (suggestionsMatch && suggestionsMatch[1]) {
        suggestions = suggestionsMatch[1].split("|").map(q => q.trim());
    }
    const cleanedContent = content.replace(/<suggestions>\s*([\s\S]*?)\s*<\/suggestions>/, "").replace(/\n{3,}/g, "\n\n").trim();

    return { content: cleanedContent, suggestions };
};

export const cutSuggestionsFromContent = (content: string): string => {
 const suggestionsMatch = content.match(/<suggestions>\s*([\s\S]*?)\s*<\/suggestions>/);
    if (suggestionsMatch && suggestionsMatch[1]) {
        return content.replace(/<suggestions>\s*([\s\S]*?)\s*<\/suggestions>/, "").replace(/\n{3,}/g, "").trim();
    }
    return content;
}